import { defineStore } from 'pinia'
import { getTemplateConfig, getModuleTemplate } from '@/api/template'

export const useTemplateStore = defineStore('template', {
  state: () => ({
    currentTemplate: 'default',
    adminTemplate: 'default',
    moduleTemplates: {},
    loaded: false,
    loading: false,
    error: null
  }),

  getters: {
    getModuleTemplate: (state) => (module) => {
      return state.moduleTemplates[module] || state.currentTemplate
    }
  },

  actions: {
    async fetchTemplateConfig() {
      if (this.loaded || this.loading) return
      
      this.loading = true
      this.error = null
      
      try {
        const response = await getTemplateConfig()
        if (response && response.data) {
          this.currentTemplate = response.data.template || 'default'
          this.adminTemplate = response.data.admin_template || 'default'
          this.moduleTemplates = response.data.module_templates || {}
          this.loaded = true
        }
      } catch (error) {
        console.error('Failed to fetch template config:', error)
        this.error = error.message
      } finally {
        this.loading = false
      }
    },

    async fetchModuleTemplate(module) {
      try {
        const response = await getModuleTemplate(module)
        if (response && response.data) {
          if (response.data.is_custom) {
            this.moduleTemplates[module] = response.data.template
          }
          return response.data.template
        }
        return this.currentTemplate
      } catch (error) {
        console.error('Failed to fetch module template:', error)
        return this.currentTemplate
      }
    },

    getTemplateForModule(module) {
      return this.moduleTemplates[module] || this.currentTemplate
    }
  }
})
